export default __webpack_public_path__ + "static/media/NBTC-logo.de7da069.png";